<template>
    <div>
        <!-- HEAD -->

        <div class="head row p-0 g-0" data-aos="fade-in" data-aos-delay="100" data-aos-duration="3000" >
            <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 p-0">
                <img :src="`${publicPath}img/01sostenibilidad.jpg`" class="img-responsive">
            </div>
            <div class="headRight p-3 pt-xl-2 px-xl-5 px-xxl-0 ps-xxl-5">
                <div class="row justify-content-end">
                    <div class="col-2 m-0 me-3  mb-4 mt-3 p-0">
                        <img :src="`${publicPath}img/01sostenibilidad-headIcon.gif`" class="img-responsive">
                    </div>
                </div>
                <h2>{{ $t('sos.sostenibilidad') }}</h2>
                <p class="text-end pt-2 pt-xl-3">{{ $t('sos.intro') }}</p>
            </div>
        </div>

        <!-- end HEAD -->

        <div class="contingut bg-white row g-0">
            <div class="row g-0">
                <div class="col-10 m-auto pt-5 pb-3">
                    <h2 class="mb-3" data-aos="fade" data-aos-duration="1500">{{ $t('sos.ocho-lineas-de-trabajo-en-sostenibilidad') }}</h2>
                    <h4 class="text-turquesa px-1 mx-0 mx-lg-5" data-aos="fade-left" data-aos-duration="1000">{{ $t('sos.txt1') }}</h4>
                </div>
            </div>
            <div class="row g-0">
                <div class="col-10 m-auto">
                    <div class="row g-0 py-4">
                        <div class="col-12 col-lg-3 py-1 py-lg-0" data-aos="fade-up" data-aos-duration="1500" data-bs-toggle="collapse" href="#collapse01" aria-expanded="false" aria-controls="collapse01">
                            <img :src="`${publicPath}img/01sostenibilidadL1${locale}.gif`" class="img-responsive fitxa">
                            <div class="collapse text-center text-lg-start px-1 px-lg-2 px-xxl-4 mt-2"  id="collapse01">
                                <p>{{ $t('sos.descarbonizacion-txt1') }}</p>
                                <p>{{ $t('sos.descarbonizacion-txt2') }}</p>
                            </div>
                        </div>
                        <div class="col-12 col-lg-3 py-1 py-lg-0" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1300" data-bs-toggle="collapse" href="#collapse02" aria-expanded="false" aria-controls="collapse02">
                            <img :src="`${publicPath}img/01sostenibilidadL2${locale}.gif`" class="img-responsive fitxa">
                            <div class="collapse text-center text-lg-start px-1 px-lg-2 px-xxl-4 mt-2"  id="collapse02">
                                  <p>{{ $t('sos.mat-1') }}</p>
                                  <p>{{ $t('sos.mat-2') }}</p>
                                  <p>{{ $t('sos.mat-3') }}</p>
                            </div>
                      </div>
                      <div class="col-12 col-lg-3 py-1 py-lg-0" data-aos="fade-up" data-aos-delay="400" data-aos-duration="1100" data-bs-toggle="collapse" href="#collapse03" aria-expanded="false" aria-controls="collapse03">
                          <img :src="`${publicPath}img/01sostenibilidadL3${locale}.gif`" class="img-responsive fitxa">
                          <div class="collapse text-center text-lg-start px-1 px-lg-2 px-xxl-4 mt-2"  id="collapse03">
                              <p>{{ $t('sos.ps-txt1') }}</p>
                              <p>{{ $t('sos.ps-txt2') }}</p>
                          </div>
                      </div>
                      <div class="col-12 col-lg-3 py-1 py-lg-0" data-aos="fade-up" data-aos-delay="600" data-aos-duration="900" data-bs-toggle="collapse" href="#collapse04" aria-expanded="false" aria-controls="collapse04">
                          <img :src="`${publicPath}img/01sostenibilidadL4${locale}.gif`" class="img-responsive fitxa">
                          <div class="collapse text-center text-lg-start px-1 px-lg-2 px-xxl-4 mt-2"  id="collapse04">
                              <p>{{ $t('sos.d-txt1') }}</p>
                              <p>{{ $t('sos.d-txt2') }}</p>
                          </div>
                      </div>
                  </div>
                  <div class="row g-0 py-4">
                      <div class="col-12 col-lg-3 py-1 py-lg-0" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1300" data-bs-toggle="collapse" href="#collapse05" aria-expanded="false" aria-controls="collapse05">
                          <img :src="`${publicPath}img/01sostenibilidadL5${locale}.gif`" class="img-responsive fitxa">
                          <div class="collapse text-center text-lg-start px-1 px-lg-2 px-xxl-4 mt-2"  id="collapse05">
                              <p>{{ $t('sos.c-2') }}</p>
                              <p>{{ $t('sos.c-3') }}</p>
                          </div>
                      </div>
                      <div class="col-12 col-lg-3 py-1 py-lg-0" data-aos="fade-up" data-aos-delay="400" data-aos-duration="1100" data-bs-toggle="collapse" href="#collapse06" aria-expanded="false" aria-controls="collapse06">
                          <img :src="`${publicPath}img/01sostenibilidadL6${locale}.gif`" class="img-responsive fitxa">
                          <div class="collapse text-center text-lg-start px-1 px-lg-2 px-xxl-4 mt-2"  id="collapse06">
                                <p>{{ $t('sos.ca-1') }}</p>
                          </div>
                    </div>
                    <div class="col-12 col-lg-3 py-1 py-lg-0" data-aos="fade-up" data-aos-delay="600" data-aos-duration="900" data-bs-toggle="collapse" href="#collapse07" aria-expanded="false" aria-controls="collapse07">
                        <img :src="`${publicPath}img/01sostenibilidadL7${locale}.gif`" class="img-responsive fitxa">
                        <div class="collapse text-center text-lg-start px-1 px-lg-2 px-xxl-4 mt-2"  id="collapse07">
                            <p>{{ $t('sos.optimizar-la-eficiencia-de-los-espacios-de-carga-en-envios') }}</p>
                            <p>{{ $t('sos.minimizar-los-envios-mediante-optimizacion-de-rutas') }}</p>
                          </div>
                      </div>
                      <div class="col-12 col-lg-3 py-1 py-lg-0" data-aos="fade-up" data-aos-delay="800" data-aos-duration="700" data-bs-toggle="collapse" href="#collapse08" aria-expanded="false" aria-controls="collapse08">
                          <img :src="`${publicPath}img/01sostenibilidadL8${locale}.gif`" class="img-responsive fitxa">
                          <div class="collapse text-center text-lg-start px-1 px-lg-2 px-xxl-4 mt-2"  id="collapse08">
                              <p>{{ $t('sos.informar-e-implicar-a-todos-los-empleados-en-la-estrategia-de-sostenibilidad') }}</p>
                              <p>{{ $t('sos.comunicar-el-progreso-de-las-iniciativas-del-grupo-y-mejorar-los-sistemas-y-parametros-de-reporting') }}</p>
                          </div>
                      </div>
                  </div>
              <hr class=" bg-darkBlue my-5">
              </div>
          </div>
          <div class="row g-0">
              <div class="col-12 col-lg-10 m-auto py-3">
                  <div class="row bg-darkBlue g-0 ">
                      <div class="col-12 m-0 p-0">
                          <img :src="`${publicPath}img/01transformacionPlacas.jpg`" class="img-responsive">
                          <div class="row justify-content-center">
                              <div class="col-12 col-xxl-10 p-5">
                                  <h2 class="text-white mb-4 px-0 px-lg-5">{{ $t('sos.objetivo-2045-neutralidad-de-carbono') }}</h2>
                                  <h4 class="text-blau px-0 px-lg-5">{{ $t('sos.txt2') }}</h4>
                                  <hr class="my-5 bg-Blue">
                                  <div class="row g-0">
                                      <div class="col-lg-4 col-12 pe-0 pe-lg-5 pb-3" data-aos="fade" data-aos-duration="1000">
                                          <p class="text-white text-center text-lg-start"><strong class="text-turquesa" style="font-size: 1.5em">1.</strong> {{ $t('sos.txt3') }}</p>
                                      </div>
                                      <div class="col-lg-4 col-12 px-0 px-lg-2 pb-3" data-aos="fade" data-aos-delay="100" data-aos-duration="1000">
                                          <p class="text-white  text-center text-lg-start"><strong class="text-turquesa" style="font-size: 1.5em">2.</strong> {{ $t('sos.txt4') }}</p>
                                      </div>
                                      <div class="col-lg-4 col-12 ps-0 ps-lg-5 pb-3" data-aos="fade" data-aos-delay="200" data-aos-duration="800">
                                          <p class="text-white  text-center text-lg-start"><strong class="text-turquesa" style="font-size: 1.5em">3.</strong> {{ $t('sos.txt5') }}</p>
                                      </div>
                                      <div class="col-lg-4 col-12 pe-0 pe-lg-5 pb-3" data-aos="fade" data-aos-delay="300" data-aos-duration="800">
                                          <p class="text-white  text-center text-lg-start"><strong class="text-turquesa" style="font-size: 1.5em">4.</strong> {{ $t('sos.txt6') }}</p>
                                      </div>
                                      <div class="col-lg-4 col-12 px-0 px-lg-2 pb-3" data-aos="fade" data-aos-delay="400" data-aos-duration="700">
                                          <p class="text-white  text-center text-lg-start"><strong class="text-turquesa" style="font-size: 1.5em">5.</strong> {{ $t('sos.txt7') }}</p>
                                      </div>
                                      <div class="col-lg-4 col-12 ps-0 ps-lg-5 pb-3" data-aos="fade" data-aos-delay="500" data-aos-duration="600">
                                          <p class="text-white  text-center text-lg-start"><strong class="text-turquesa" style="font-size: 1.5em">6.</strong> {{ $t('sos.txt8') }}</p>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <hr class=" bg-darkBlue my-5">

                  <div class="row g-0 justify-content-between mt-5">
                      <div class="col-lg-5 col-12 px-3 px-lg-0 pb-5 pb-lg-0 text-center text-lg-start" data-aos="fade-up" data-aos-duration="600">
                          <img :src="`${publicPath}img/01sostenibilidadBN.jpg`" class="img-responsive">
                          <h3 class="text-blau py-3">{{ $t('sos.tit9') }}</h3>
                          <p>{{ $t('sos.txt9') }} </p>
                      </div>
                      <div class="col-lg-5 col-12 px-3 px-lg-0 text-center text-lg-start" data-aos="fade-up" data-aos-duration="1000">
                          <img :src="`${publicPath}img/01sostenibilidadFustes.jpg`" class="img-responsive">
                          <h3 class="text-blau py-3">{{ $t('sos.tit10') }}</h3>
                          <p>{{ $t('sos.txt10') }}</p>
                      </div>
                  </div>

                  <hr class=" bg-darkBlue my-5">

                  <div class="row bg-darkBlue g-0 ">
                      <div class="col-12 m-0 p-0">
                          <div class="row justify-content-center">
                              <div class="col-12 col-xxl-10 p-5">
                                  <h3 class="text-white my-4">{{ $t('sos.tit11') }} </h3>
                                  <h4 class="text-turquesa">{{ $t('sos.txt11') }}</h4>
                                  <hr class="my-5 bg-Blue">
                                  <div class="row align-items-top pb-5">
                                      <div class="col-12 col-md-4" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000" data-aos-id="start-counter-sosten">
                                          <img :src="`${publicPath}img/01sostenibilidadNuvol.png`" class="img-responsive pb-5">
                                          <p class="numbersPeu text-white">{{ $t('sos.energia') }}</p>
                                          <p class="numbersProyectos text-white">
                                              <AnimatedNumber
                                                  ref='counter_co2'
                                                  :startAmount='0'
                                                  :endAmount='26'
                                                  :duration='3'
                                                  prefix='-'
                                                  suffix='%'
                                                  separator='.'
                                                  decimalSeparator=','
                                                  :decimals='0'
                                                  :autoinit='true'
                                                  />
                                          </p>
                                          <p class="text-white">{{ $t('sos.emisiones-co2') }}</p>
                                      </div>
                                      <div class="col-12 col-md-4" data-aos="fade-up" data-aos-duration="1000" data-aos-id="start-counter2">
                                          <img :src="`${publicPath}img/01sostenibilidadGota.png`" class="img-responsive pb-5">
                                          <p class="numbersPeu text-white">{{ $t('sos.agua') }}</p>
                                          <p class="numbersProyectos text-white">
                                              <AnimatedNumber
                                                  ref='counter_agua'
                                                  :startAmount='0'
                                                  :endAmount='26'
                                                  :duration='3'
                                                  prefix='-'
                                                  suffix='%'
                                                  separator='.'
                                                  decimalSeparator=','
                                                  :decimals='0'
                                                  :autoinit='true'
                                                  />
                                          </p>
                                          <p class="text-white">{{ $t('sos.consumo-de-agua') }}</p>
                                      </div>
                                      <div class="col-12 col-md-4" data-aos="fade-right" data-aos-delay="500" data-aos-duration="1000" data-aos-id="start-counter3">
                                          <img :src="`${publicPath}img/01sostenibilidadBasura.png`" class="img-responsive pb-5">
                                          <p class="numbersPeu text-white">{{ $t('sos.residuos') }}</p>
                                          <p class="numbersProyectos text-white">
                                              <AnimatedNumber
                                                  ref='counter_residuos'
                                                  :startAmount='0'
                                                  :endAmount='33'
                                                  :duration='3'
                                                  prefix='-'
                                                  suffix='%'
                                                  separator='.'
                                                  decimalSeparator=','
                                                  :decimals='0'
                                                  :autoinit='true'
                                                  />
                                          </p>
                                          <p class="text-white">{{ $t('sos.residuos-generados') }}</p>
                                      </div>
                                  </div>
                                  <p class="text-white"><small>{{ $t('sos.txt12') }}</small></p>
                              </div>
                          </div>
                      </div>
                  </div>


                  <hr class=" bg-Blue my-5">

                  <h2 class="mb-4" data-aos="fade" data-aos-duration="1500">{{ $t('sos.integracion-transversal-de-la-sostenibilidad') }}</h2>
                  <p class="px-3 px-lg-0" data-aos="fade-left" data-aos-duration="1000">{{ $t('sos.txt13') }}</p>

              </div>
          </div>

          <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel" data-bs-wrap="false" >
              <div class="carousel-inner">
                  <div class="carousel-item active">
                      <div class="row justify-content-center pb-5 mb-5">
                          <div class="col-12 col-md-5 col-lg-5 p-3 pe-3 pe-lg-5 text-center text-lg-start">
                              <img :src="`${publicPath}img/01sostenibilidadVella.jpg`" class="img-responsive mb-4">
                              <h4 class="text-turquesa my-3">{{ $t('sos.jumpthegap-r-se-adapta-a-los-retos-de-la-agenda-2030') }}</h4>
                              <p>{{ $t('sos.txt14') }}</p>
                          </div>
                          <div class="col-12 col-md-5 col-lg-5 p-3 ps-3 ps-lg-5 text-center text-lg-start">
                              <img :src="`${publicPath}img/01sostenibilidadPresentacio.jpg`" class="img-responsive mb-4">
                              <h4 class="text-turquesa my-3">{{ $t('sos.roca-galleries-espacios-de-debate-sobre-sostenibilidad') }}</h4>
                              <p>{{ $t('sos.txt15') }}</p>
                          </div>
                      </div>
                  </div>
                  <div class="carousel-item">
                      <div class="row justify-content-center pb-5 mb-5">
                          <div class="col-12 col-md-5 col-lg-5 p-3 pe-3 pe-lg-5 text-center text-lg-start">
                              <img :src="`${publicPath}img/01sostenibilidadMostra.jpg`" class="img-responsive mb-4">
                              <h4 class="text-turquesa my-3">{{ $t('sos.investigacion-sobre-los-espacios-sanitarios-en-las-escuelas') }}</h4>
                              <p>{{ $t('sos.txt16') }}</p>
                          </div>
                          <div class="col-12 col-md-5 col-lg-5 p-3 ps-3 ps-lg-5  text-center text-lg-start">
                              <img :src="`${publicPath}img/01sostenibilidadMoli.jpg`" class="img-responsive mb-4">
                              <h4 class="text-turquesa my-3">{{ $t('sos.vinculacion-de-la-financiacion-a-criterios-de-sostenibilidad') }}</h4>
                              <p>{{ $t('sos.txt17') }}</p>
                          </div>
                      </div>
                  </div>
              </div>
              <button class="carousel-control-prev d-none d-lg-block" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                  <img :src="`${publicPath}img/carouselBack.png`" class="img-responsive">
                  <span class="visually-hidden">{{ $t('previous') }}</span>
              </button>
              <button class="carousel-control-next d-none d-lg-block" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                  <img :src="`${publicPath}img/carouselNext.png`" class="img-responsive">
                  <span class="visually-hidden">{{ $t('next') }}</span>
              </button>
          </div>

      </div>

      <div class="contingut bg-white row g-0 mb-5 pb-5">
          <div class="col-12 py-5 mb-5 fonsGris position-relative">
              <h3 class="pb-3 mb-3">{{ $t('contribucion-a-los-ods') }}</h3>
              <div class="row justify-content-center">
                  <div class="col-12 col-lg-3 col-xxl-2 col-md-auto mb-4 text-center text-lg-start">
                      <p>{{ $t('impacto-directo') }}</p>
                      <img :src="`${publicPath}img/01transformacion-icono01.gif`" class="img-responsive m-1">
                      <img :src="`${publicPath}img/01crecimiento-icono03.gif`" class="img-responsive m-1">
                      <img :src="`${publicPath}img/01excelencia-icono03.gif`" class="img-responsive m-1">
                  </div>
                  <div class="col-md-auto border-start mb-4 text-center text-lg-start">
                      <p>{{ $t('impacto-indirecto') }}</p>
                      <img :src="`${publicPath}img/01excelencia-icono04.gif`" class="img-responsive m-1">
                      <img :src="`${publicPath}img/01crecimiento-icono05.gif`" class="img-responsive m-1">
                      <img :src="`${publicPath}img/01crecimiento-icono06.gif`" class="img-responsive m-1">
                      <img :src="`${publicPath}img/01excelencia-icono07.gif`" class="img-responsive m-1">
                      <img :src="`${publicPath}img/01transformacion-icono08.gif`" class="img-responsive m-1">
                  </div>
              </div>
          </div>

          <hr>
          <div class="row p-0 g-0">
              <div class="col-6 p-3 p-lg-0 m-0 pb-3 text-start">
                  <localized-link class="footerLink" to="/avanzando-hacia-el-futuro/transformacion-digital"><img :src="`${publicPath}img/breadcrumbBack.gif`" class="img-responsive" width="6"> {{ $t("nav.transformacion-digital") }}</localized-link>
              </div>
              <div class="col-6 p-3 p-lg-0 m-0 pb-3 text-end">
                  <localized-link class="footerLink" to="/avanzando-hacia-el-futuro/personas">{{ $t("nav.personas") }} <img :src="`${publicPath}img/breadcrumbGo.gif`" class="img-responsive" width="6"></localized-link>
              </div>
          </div>

      </div>

  </div>
</template>
<script>
  import AnimatedNumber from 'vue3-autocounter'

  export default {
      name: "SostenibilidadView",
      components: {
          AnimatedNumber,
      },
      data() {
          return {
              publicPath: process.env.BASE_URL,
              locale:this.$i18n.locale,
          }
      },
      mounted() {
        document.addEventListener('aos:in:start-counter-sosten', this.startCounter);
      },
      methods: {
        startCounter() {
          if (this.$refs.counter_co2 != null) {
            this.$refs.counter_co2.start();
          }
          if (this.$refs.counter_agua != null) {
            this.$refs.counter_agua.start();
          }
          if (this.$refs.counter_residuos != null) {
            this.$refs.counter_residuos.start();
          }
        }
      }
  }

</script>
